<template>
  <div
    @contextmenu="selectComponentDEV($event, schema.model)"
    :class="['d-flex', getSelectedDEV && 'dev-selected-component']"
    :key="generateId(schema.model)"
  >
    <i4pro-icon-popover
      v-if="schema.attributesInfo"
      :class="[schema.attributesInfo.right ? 'ml-1 order-2' : 'mr-1']"
      :schema="schema"
      :model="model"
    ></i4pro-icon-popover>

    <v-autocomplete
      :name="schema.model"
      :id="generateId(schema.model)"
      :rules="rules"
      :search-input.sync="search"
      :value="schema.value"
      v-model="value"
      return-object
      @blur="onBlur"
      @change="onChange"
      @focus="onFocus"
      @input="onInput"
      @click:clear="clear()"
      v-bind="schema.attributesSelect"
      :disabled="schema.readonly"
    >
      <template v-slot:label>
        {{ schema.attributesSelect.label }}
        <span v-if="schema.rules.includes('required')" class="red--text">*</span>
      </template>

      <template v-slot:no-data>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>
              Nenhum resultado para: "
              <strong>{{ search }}</strong
              >"
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
import { abstractField } from 'vue-form-generator';
import devComponentMixin from '@/mixins/dev-component-mixin';
import rulesMixin from '@/mixins/rules-mixin';
import inputEventsMixin from '@/mixins/input-events-mixin';
import componentMixin from '@/mixins/component-mixin';

export default {
  mixins: [abstractField, devComponentMixin, rulesMixin, inputEventsMixin, componentMixin],

  components: {
    i4proIconPopover: () => import('@/components/icons/i4pro-icon-popover')
  },

  data: () => ({
    search: null
  }),

  created() {
    if (this.schema.attributesSelect.multiple && this.value && this.value.length) {
      if (typeof this.value === 'string') {
        this.value = JSON.parse(this.value);
      }
    }
  },

  methods: {
    onChange: async function () {
      this.changeEvents();
    },

    clear() {
      this.$nextTick(() => (this.model[this.schema.model] = ''));
    }
  },

  watch: {
    value(val) {
      if (Array.isArray(val) && val.length > this.schema.max) {
        this.$nextTick(() => this.value.pop());
      }

      if (this.schema.attributesSelect.multiple && val) this.value = Array.isArray(val) ? val : JSON.parse(val);
    }
  }
};
</script>
